/// <amd-module name="Test/TestPlansHubRefresh/Pivots/ExecutePivot/TestPointsSortingUtility" />
import * as ExecuteConstants from "Test/TestPlansHubRefresh/Pivots/ExecutePivot/ExecuteConstants";
import { ITestPointItem } from "Test/TestPlansHubRefresh/Pivots/ExecutePivot/Redux/PointsContracts";
/**
 * Custom sorting utility to sort columns in execute tab.
 * @param columnId - Id of the the column on which sorting has to be applied
 * @param sortOrder - Sort Order of the column (asc / desc)
 */
export const getTestPointItemsComparator = function(columnId: string, sortOrder: number | undefined) {
    // set reverse to invert function comparator if sortOrder is changed
    const reverse: number = sortOrder === 0 || sortOrder === undefined ? 1 : -1;

    if (columnId === ExecuteConstants.TestCaseIdColumn) {
        return (a: ITestPointItem, b: ITestPointItem) => {
            return reverse * (a.testCaseRef.id - b.testCaseRef.id);
        };
    }

    if (columnId === ExecuteConstants.OrderColumn) {
        return (a: ITestPointItem, b: ITestPointItem) => {
            if (a.order && b.order) {
                return reverse * (a.order - b.order);
            }

            // We have an explicit return of 0 in case the order values have not been loaded by the async call yet.
            return 0;
        };
    }

    if (columnId === ExecuteConstants.OutcomeColumn) {
        return (a: ITestPointItem, b: ITestPointItem) => {
            return reverse * a.outcomeItem.outcomeString.localeCompare(b.outcomeItem.outcomeString, navigator.language);
        };
    }

    if (columnId === ExecuteConstants.TitleColumn) {
        return (a: ITestPointItem, b: ITestPointItem) => {
            return reverse * a.testCaseRef.title.localeCompare(b.testCaseRef.title, navigator.language);
        };
    }

    if (columnId === ExecuteConstants.TesterColumn) {
        return (a: ITestPointItem, b: ITestPointItem) => {
            return reverse * a.tester.displayName.localeCompare(b.tester.displayName, navigator.language);
        };
    }

    if (columnId === ExecuteConstants.ConfigurationColumn) {
        return (a: ITestPointItem, b: ITestPointItem) => {
            return reverse * a.configuration.name.localeCompare(b.configuration.name, navigator.language);
        };
    }

    if (columnId) {
        return (a: ITestPointItem, b: ITestPointItem) => {
            const columnValueA = a.columnOptionValues[columnId];
            const columnValueB = b.columnOptionValues[columnId];

            return reverse * (columnValueA > columnValueB ? 1 : columnValueA == columnValueB ? 0 : -1);
        };
    }
};
